import { useContext, useEffect, useState } from "react";
import styles from "../styles/CreateChatbot.module.css";

import { SupabaseContext } from "./Login";
import Loading from "./LoadingScreen";
import { LanguageContext } from "./App";
import { buttonVariants } from "./ui/button.tsx";
import React from "react";
import { IoSettingsOutline } from "react-icons/io5";
import { BsEye } from "react-icons/bs";
import { LiaBrainSolid } from "react-icons/lia";
import { LuBookMarked } from "react-icons/lu";
import Appearence from "./Appearence.tsx";
import KnowledgeBase from "./KnowledgeBase.tsx";
import Settings from "./Settings.tsx";
import ReactLoading from "react-loading";
import { createChatBot } from "./UploadChatBot.js";
import { FaCode } from "react-icons/fa6";
import { MdOutlineAccountCircle } from "react-icons/md";
import AccountSettings from "./AccountSettings.tsx";
import Billing from "./Billing.tsx";
import { LiaMoneyBillWaveSolid } from "react-icons/lia";
import Embedding from "./Embedding.tsx";
import Contacts from "./Contacts.tsx";
import Main from "./Main.tsx";
import { IoHomeOutline } from "react-icons/io5";

async function findChatBot(supabase) {
  const userSession = await supabase.auth.getSession();

  const { data, e } = await supabase.from("clients").select();
  const supabaseObject = data.find(
    (e) => e.user_email === userSession.data.session.user.email
  );

  return supabaseObject;
}

export function Dashboard() {
  const [chatbot, setChatbot] = useState<any>();
  const [section, setSection] = useState("main");

  const [messagesLeft, setmessagesLeft] = useState(0);
  const [numOfMessages, setnumOfMessages] = useState(0);
  const [trained, setTrained] = useState(false);

  const [id, setId] = useState<string>("");

  const supabase = useContext(SupabaseContext);

  const [language, setLanguage] = useContext(LanguageContext);
  const [collected_emails, setCollected_emails] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [loadingCreateBot, setLoadingCreateBot] = useState(false);

  async function checkBotName() {
    const regex = /^[a-zA-Z0-9]+$/;

    setLoadingCreateBot(true);
    if (regex.test(id)) {
      const supabaseResponse = await supabase.from("clients").select("*");
      for (let index = 0; index < supabaseResponse.data.length; index++) {
        if (supabaseResponse.data[index].name === id) {
          if (language === "en") {
            alert("Sorry, this ID is taken!");
          } else {
            alert("Простите, этот ID чат-бота уже занят!");
          }
          setLoadingCreateBot(false);
          return;
        }
      }
    } else {
      if (language === "en") {
        alert(
          "Sorry, you can only use English letters and numbers in chatbot ID! Check for any spaces"
        );
      } else {
        alert(
          "Простите, в ID чат-бота можно использовать только латинские буквы и цифры! Проверьте на наличие лишних пробелов"
        );
      }
      setLoadingCreateBot(false);
      return;
    }

    // if okay
    await createChatBot(
      id,
      "Your company",
      [""],

      [""],

      "👋 Any questions? Ask me!",
      "Your company's AI support",
      "🤖 AI chatbot",
      "",
      "",
      "-1002077617509",
      "#845AFA",
      "#4E4F5C",
      "#845AFA",
      "#560bad",
      "#ffffff",
      "#000000",
      "#ffffff",
      "#4E4F5C",
      3000,
      "",

      "Enter your email",
      "Thank you",
      false,
      false,
      true,
      language
    );
    findChatBot(supabase).then(async (chatbot) => {
      console.log(chatbot);
      if (chatbot !== undefined) {
        setnumOfMessages(chatbot.numOfMessages);
        setmessagesLeft(chatbot.messages);
        setTrained(chatbot.updated);
        setCollected_emails(chatbot.collected_emails);
        setChatbot(chatbot);
      }

      // Create account if not cerated yet
      supabase.auth.onAuthStateChange((_event, session) => {
        createUserData(session, supabase);
      });

      setLoading(false);
    });
    setLoadingCreateBot(false);
  }

  useEffect(() => {
    setLoading(true);
    findChatBot(supabase).then(async (chatbot) => {
      console.log(chatbot);
      if (chatbot !== undefined) {
        setnumOfMessages(chatbot.numOfMessages);
        setmessagesLeft(chatbot.messages);
        setTrained(chatbot.updated);
        setCollected_emails(chatbot.collected_emails);
        setChatbot(chatbot);
      }

      // Create account if not cerated yet
      supabase.auth.onAuthStateChange((_event, session) => {
        createUserData(session, supabase);
      });

      setLoading(false);
    });
  }, []);

  if (loading) {
    return <Loading></Loading>;
  } else {
    if (chatbot === undefined) {
      return (
        <div
          style={{
            overflowX: "hidden",
            overflowY: "hidden",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#eee",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {loadingCreateBot ? (
            <div
              style={{
                display: "flex",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent",
              }}
            >
              <ReactLoading type="spin" color="#000" height={75} width={75} />
            </div>
          ) : null}
          <input
            style={{
              height: 35,
              padding: 10,
              border: "none",
              outline: "none",
              fontSize: 20,
              transition: "all 0.15s ease",
              fontFamily: "Jost",
              fontWeight: 300,
              marginBottom: 20,
              borderRadius: 8,
              width: 260,
              textAlign: "center",
            }}
            value={id}
            placeholder={
              language === "en"
                ? "Unique chatbot ID..."
                : "Уникальный код чат-бота..."
            }
            onChange={(event) => {
              setId(event.target.value);
            }}
          ></input>
          <button
            className={styles["submitBtn"]}
            style={{ padding: 30, width: 260 }}
            onClick={() => {
              checkBotName();
            }}
          >
            <a
              style={{
                color: "#000",
                fontSize: 20,
              }}
            >
              {language === "en" ? "Create a chatbot" : "Создать"}
            </a>
          </button>
          <h5
            style={{
              fontWeight: 900,
              fontFamily: "Jost",
              fontSize: 12,
              color: "#000",

              marginTop: 20,
            }}
          >
            {language === "en"
              ? "(Please, use PC to create a chatbot)"
              : "(Лучше использовать ПК)"}
          </h5>
        </div>
      );
    } else {
      return (
        <div
          style={{
            overflowX: "hidden",
            overflowY: "hidden",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#eee",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "row", height: "100%" }}
          >
            <div className={styles.buttons}>
              <h5
                style={{
                  fontWeight: 900,
                  fontFamily: "Jost",
                  fontSize: 16,
                  color: "#000",

                  margin: 15,
                }}
              >
                eAIq chat
              </h5>
              <NavButton
                sectionTitle="main"
                section={section}
                setSection={setSection}
                icon={() => <IoHomeOutline size={17} />}
                textRu="Главная"
                textEn="Main"
                language={language}
              ></NavButton>
              <NavButton
                sectionTitle="settings"
                section={section}
                setSection={setSection}
                icon={() => <IoSettingsOutline size={17} />}
                textRu="Настройки"
                textEn="Settings"
                language={language}
              ></NavButton>
              <NavButton
                icon={() => <BsEye size={17} />}
                section={section}
                sectionTitle="appearence"
                setSection={setSection}
                textRu="Внешность"
                textEn="Appearence"
                language={language}
              ></NavButton>
              <NavButton
                icon={() => <LiaBrainSolid size={17} />}
                section={section}
                sectionTitle="knowledgebase"
                setSection={setSection}
                textRu="База знаний"
                textEn="Knowledge base"
                language={language}
              ></NavButton>

              <NavButton
                icon={() => <LuBookMarked size={17} />}
                sectionTitle="contacts"
                section={section}
                setSection={setSection}
                textRu="Контакты"
                textEn="Collected Contacts"
                language={language}
              ></NavButton>
              {/* <NavButton
                icon={() => <MdOutlineIntegrationInstructions size={17} />}
                sectionTitle="integrations"
                section={section}
                setSection={setSection}
                textRu="Интеграции"
                textEn="Integrations"
                language={language}
              ></NavButton> */}

              <NavButton
                icon={() => <FaCode size={17} />}
                sectionTitle="embedding"
                section={section}
                setSection={setSection}
                textRu="Код для сайта"
                textEn="Embed code"
                language={language}
              ></NavButton>
              <div style={{ marginTop: 30 }}></div>
              <NavButton
                icon={() => <LiaMoneyBillWaveSolid size={17} />}
                sectionTitle="billing"
                section={section}
                setSection={setSection}
                textRu="Оплата"
                textEn="Billing"
                language={language}
              ></NavButton>

              <button
                className={buttonVariants({ variant: "ghost" })}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "88%",
                  marginLeft: 20,
                  backgroundColor:
                    section === "accountsettings" ? "#16a34a" : "transparent",
                  marginRight: 20,
                  borderRadius: 8,
                  paddingLeft: 20,
                  paddingRight: 20,
                  bottom: 0,
                }}
                onClick={() => {
                  setSection("accountsettings");
                }}
              >
                <MdOutlineAccountCircle size={17} />
                <a
                  style={{
                    color: "#000",
                    marginLeft: 10,
                  }}
                >
                  {language === "en"
                    ? "Account Settings"
                    : "Настройки аккаунта"}
                </a>
              </button>
            </div>
            <div className={styles.mainContainer}>
              {section === "appearence" ? (
                <Appearence chatbot={chatbot}></Appearence>
              ) : (
                <>
                  {section === "knowledgebase" ? (
                    <KnowledgeBase chatbot={chatbot}></KnowledgeBase>
                  ) : (
                    <>
                      {section === "settings" ? (
                        <Settings chatbot={chatbot}></Settings>
                      ) : (
                        <>
                          {section === "accountsettings" ? (
                            <AccountSettings></AccountSettings>
                          ) : (
                            <>
                              {section === "billing" ? (
                                <Billing
                                  language={language}
                                  chatbot={chatbot}
                                ></Billing>
                              ) : (
                                <>
                                  {section === "embedding" ? (
                                    <Embedding
                                      supabaseData={chatbot.name}
                                    ></Embedding>
                                  ) : (
                                    <>
                                      {section === "contacts" ? (
                                        <Contacts
                                          language={language}
                                          collected_emails={collected_emails}
                                        ></Contacts>
                                      ) : (
                                        <>
                                          {section === "main" ? (
                                            <Main
                                              language={language}
                                              chatbot={chatbot}
                                            ></Main>
                                          ) : null}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

async function createUserData(user, supabase) {
  if (user !== null) {
    const currentUser = await supabase
      .from("users")
      .select()
      .eq("user_email", user.user.email);

    if (currentUser.data.length === 0) {
      try {
        const { error } = await supabase.from("users").insert({
          user_email: user.user.email,
        });
        console.log(error);
      } catch (error) {
        console.log(error);
      }
    }
  }
}

function NavButton({
  section,
  setSection,
  textRu,
  textEn,
  language,
  sectionTitle,
  icon,
}) {
  return (
    <button
      className={buttonVariants({ variant: "ghost" })}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "88%",
        marginLeft: 20,
        backgroundColor: section === sectionTitle ? "#16a34a" : "transparent",
        marginRight: 20,
        borderRadius: 8,
        paddingLeft: 20,
        paddingRight: 20,
      }}
      onClick={() => {
        setSection(sectionTitle);
      }}
    >
      {icon()}
      <a
        style={{
          color: "#000",
          marginLeft: 10,
        }}
      >
        {language === "en" ? textEn : textRu}
      </a>
    </button>
  );
}
